import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives';
import { created } from '../../utils';

export const CustomerEventSchema = oz.object({ 
  eventId: oz.string(),
  customerId: ObjectIdSchema, 
});

export type CustomerEvent = oz.infer<typeof CustomerEventSchema>;

export const DbCustomerEventSchema = created(CustomerEventSchema).openapi('DbCustomerEvent');

export type DbCustomerEvent = oz.infer<typeof DbCustomerEventSchema>;
